export default __webpack_public_path__ + "static/media/property.8fd075c5.png";